/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForTclItsmUserConfiguration extends models.GovernanceConfigurationBaseForForTclItsm {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForTclItsmUserConfiguration");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForTclItsmUserConfiguration.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForTclItsmUserConfiguration>): GovernanceConfigurationForTclItsmUserConfiguration {
        let obj = Object.assign(new GovernanceConfigurationForTclItsmUserConfiguration(), model);
        GovernanceConfigurationForTclItsmUserConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForTclItsmUserConfiguration>): GovernanceConfigurationForTclItsmUserConfiguration {
        if (!model) return null;
        return GovernanceConfigurationForTclItsmUserConfiguration.newInstance(<GovernanceConfigurationForTclItsmUserConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForTclItsmUserConfiguration) {
        if (!obj) return;

        models.GovernanceConfigurationForTclItsmUserConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForTclItsmUserConfiguration): boolean {
        if (models.GovernanceConfigurationBaseForForTclItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForTclItsmUserConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.action_mapping) {
            for (let val of this.action_mapping) {
                models.TclItsmUserActionmapping.fixupPrototype(val);
            }
        }
        if (this.attribute_encryption) {
            for (let val of this.attribute_encryption) {
                models.TclItsmUserAttributeEncryption.fixupPrototype(val);
            }
        }
    }

    /**
     * Action mapping for TCL ITSM
     */
    action_mapping: Array<models.TclItsmUserActionmapping>;

    /**
     * Attribute encryption for TCL ITSM
     */
    attribute_encryption: Array<models.TclItsmUserAttributeEncryption>;

}
